export function noWidows(string_: string, n = 3): string {
  const words = string_.split(" ");
  const l = words.length;

  // eslint-disable-next-line unicorn/no-array-reduce
  return words.reduce((string_, word, index) => {
    return index < l - n ? string_ + " " + word : string_ + "\u00A0" + word;
  }, "");
}
